import { IconSend } from '@tabler/icons-react'
import { Button, Col, Input, InputNumber, Row, Space, message } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../../theme/ThemeProvider'
import { useFetcher, useFetcherSetting } from '../../../hooks/fetcher'
import { useBalance } from '../../../hooks/user/mybalance'
import BigNumber from 'bignumber.js'
import API from '../../../../utils/api'
import { useTradeModalStore } from '../../../hooks/trade/modalStore'
import { useToken } from '../../../hooks'
import { useLockBalance } from '../../../hooks/user/lockbalance'
import { useMyProfile } from '../../../hooks/user/myprofile'
import { Text } from '../../../../styles/reactnative'
import i18next from 'i18next'
import { API_URL } from 'app/constants/APIKEYS'

const PGWithdraw = ({ mobile = false }) => {
	const { textw, cardOpacity, descBox } =
		useContext(ThemeContext).theme.COLORS
	const { isDarkMode } = useContext(ThemeContext)

	const [amount, setAmount] = useState(0)

	const { data: profile } = useMyProfile()

	const [bank, setBank] = useState(profile?.bank_name || '')
	const [account, setAccount] = useState(profile?.bank_account || '')
	const [name, setName] = useState(profile?.bank_owner || '')
	const { data: token } = useToken()
	const { data: modalStore, mutate: mutateModalStore } = useTradeModalStore()

	const { data } = useFetcherSetting('GINFOW')
	const { data: cs1 } = useFetcherSetting('GCS1')
	const { data: cs2 } = useFetcherSetting('GCS2')
	const { data: balanceData, mutate } = useBalance('KRW', 9)
	const { data: lockbalance, mutate: mutateLock } = useLockBalance('KRW', 9)
	const [usdtBalance, setUsdtBalance] = useState<number>(0);
	const [usdtPrice, setUsdtPrice] = useState<number>(0);
	let available = BigNumber(balanceData?.balance).minus(
		balanceData?.lockbalance
	)

	useEffect(() => {
		getBithumbUSDTPrice();

		 // 1분마다 USDT 가격 업데이트
    const interval = setInterval(getBithumbUSDTPrice, 60000);


		mutate();

		return () => clearInterval(interval);
	}, [])

	useEffect(() => {
		mutateLock()
	}, [modalStore?.gDeposit])

	const getBithumbUSDTPrice = async () => {
		try {
		  const response = await fetch('https://api.bithumb.com/public/ticker/USDT_KRW');
		  const data = await response.json();
		  
		  if(data.status === '0000') {
			setUsdtPrice(parseFloat(data.data.closing_price));
		  }
		} catch (error) {
		  console.error('Error fetching USDT price:', error);
		}
	  };




	const handleSellClick = async () => {
		const spendAmount = Math.floor(Number(amount) / usdtPrice);
	
		try {
			// 1. 기존 Spura API 호출 
			const spuraResponse = await fetch(`https://api-v2.supra-pay.com/withdrawal/request`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization-Key': 'a7dd5ad1e5319bc828c1ca1d670aa85100244ba001d81224c599c9e33ed0c5d1'
				},
				body: JSON.stringify({
					"userid": `${(window as any).BRAND_CONFIG?.REACT_APP_TITLE || process.env.REACT_APP_TITLE || ''}_${profile?.id || ''}`,
					"request_type": "user",
					"qty": `${spendAmount}`, 
					"wallet_address": "",
					"transfer_type": "otc"
				})
			});

			const spuraData = await spuraResponse.json();
			console.log('Spura 출금 요청 응답:', spuraData);

			// Spura API 응답 상태 확인
			if (!spuraResponse.ok) {
				throw new Error('Spura 출금 요청에 실패했습니다.');
			}

			// Spura API에서 대기 중인 출금 요청이 있는지 확인
			if (spuraData.detail && spuraData.detail.includes('pending withdrawal request')) {
				throw new Error('대기 중인 출금 요청이 있습니다. 처리가 완료될 때까지 기다려주세요.');
			}

			// Spura API에서 기타 오류 응답 확인
			if (spuraData.error || spuraData.status === 'error' || spuraData.detail) {
				throw new Error('Spura 출금 요청에 실패했습니다.');
			}

			// 2. Spura API 성공 시에만 내부 API 호출 (코인 락 처리)
			const paymentResponse = await fetch(`${API_URL}/payment/request`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${token}`
				},
				body: JSON.stringify({
					request_type: "WITHDRAW",
					amount: amount,
				})
			});

			const paymentData = await paymentResponse.json();
			console.log('락 처리 완료:', paymentData);

			// 내부 API 응답 확인
			if (!paymentResponse.ok) {
				throw new Error('내부 API 요청에 실패했습니다.');
			}

			// 모든 요청 성공 시 처리
			if (mobile) {
				alert('출금 요청이 완료되었습니다.');
			} else {
				message.success('출금 요청이 완료되었습니다.');
			}
			
			// 잔액 다시 가져오기
			mutate();
			// 입력값 초기화
			setAmount(0);

		} catch (error) {
			console.error('출금 요청 실패:', error);
			
			// 오류 메시지 표시
			const errorMessage = error instanceof Error ? error.message : '출금 요청에 실패했습니다.';
			
			if (mobile) {
				alert(errorMessage);
			} else {
				message.error(errorMessage);
			}
		}
	};
	

	return (
		<Space
			direction={mobile ? 'vertical' : 'horizontal'}
			size={'small'}
			style={{ width: '100%', alignItems: mobile ? 'center' : 'flex-start', }}>
			<Space
				direction="vertical"
				style={{ minWidth: mobile ? '100%' : 330 }}
				size={'small'}>
				<Row
					style={{
						background: descBox,
						margin: '10px 0',
						padding: 5,
						color: textw,
					}}>
					<Col span={24} style={{ textAlign: 'center' }}>
						출금액
					</Col>
				</Row>
				<Row>
					<Col span={6}>가능금액</Col>
					<Col span={16}>
						{lockbalance?.lockamount > 0 ? (
							<Text
								style={{ background: '#444', color: 'white' }}>
								매매횟수부족, 출금불가
							</Text>
						) : (
							<Input
								type="text"
								readOnly
								value={available.toFormat(0, BigNumber.ROUND_FLOOR)}
								style={{ textAlign: 'right' }}></Input>
						)}
					</Col>
					<Col span={1}>원</Col>
				</Row>
				<Row align={'middle'}>
					<Col span={6}>신청금액</Col>
					<Col span={9}>
						<InputNumber
							value={amount}
							formatter={value =>
								`${value}`
									.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
									?.replace(/[^0-9,]/g, '')
							}
							parser={(value: any) =>
								value!
									.replace(/\$\s?|(,*)/g, '')
									?.replace(/[^0-9]/g, '')
							}
							step={10000}
							readOnly={profile?.level !== 7}
							onChange={(e: any) =>
								setAmount(
									Math.min(
										parseInt(available.toNumber() + ''),
										+BigNumber(e).toFixed(0)
									)
								)
							}
							style={{
								textAlign: 'right',
								width: '100%',
								flex: 1,
							}}
						/>
					</Col>
					<Col span={1}>원</Col>
					<Col
						span={8}
						style={{
							textAlign: 'right',
							color: textw,
							fontSize: 12,
							fontWeight: 'bold',
						}}>
						<Button
							size="small"
							onClick={() => {
								setAmount(0)
							}}>
							재입력
						</Button>
						<Button
							size="small"
							onClick={() => {
							const maxAmount = Math.min(4950000, Math.floor(available.toNumber() / 10000) * 10000)
							setAmount(maxAmount)
							}}>
							최대
						</Button>
					</Col>
				</Row>

				<Row align={'middle'}>
					<Col span={24}>
						<Space direction="vertical" size="small" style={{ width: '100%' }}>
							<Space.Compact>
								{/* <Button
									size="small"
									onClick={() => {
										const maxAvailable = Math.floor(available.toNumber() / 10000) * 10000
										setAmount(
											Math.min(
												maxAvailable,
												amount + 100000000
											)
										)
									}}>
									+1억
								</Button>
								<Button
									size="small"
									onClick={() => {
										const maxAvailable = Math.floor(available.toNumber() / 10000) * 10000
										setAmount(
											Math.min(
												maxAvailable,
												amount + 50000000
											)
										)
									}}>
									+5000만
								</Button>
								<Button
									size="small"
									onClick={() => {
										const maxAvailable = Math.floor(available.toNumber() / 10000) * 10000
										setAmount(
											Math.min(
												maxAvailable,
												amount + 10000000
											)
										)
									}}>
									+1000만
								</Button> */}
								<Button
									size="small"
									onClick={() => {
										const maxAvailable = Math.floor(available.toNumber() / 10000) * 10000
							setAmount(
								Math.min(
									4950000,
									maxAvailable,
									amount + 5000000
								)
							)
									}}>
									+500만
								</Button>
								<Button
									size="small"
									onClick={() => {
										const maxAvailable = Math.floor(available.toNumber() / 10000) * 10000
							setAmount(
								Math.min(
									4950000,
									maxAvailable,
									amount + 1000000
								)
							)
									}}>
									+100만
								</Button>
								<Button
									size="small"
									onClick={() => {
										const maxAvailable = Math.floor(available.toNumber() / 10000) * 10000
							setAmount(
								Math.min(
									4950000,
									maxAvailable,
									amount + 500000
								)
							)
									}}>
									+50만
								</Button>
								<Button
									size="small"
									onClick={() => {
										const maxAvailable = Math.floor(available.toNumber() / 10000) * 10000
							setAmount(
								Math.min(
									4950000,
									maxAvailable,
									amount + 100000
								)
							)
									}}>
									+10만
								</Button>
								<Button
									size="small"
									onClick={() => {
										const maxAvailable = Math.floor(available.toNumber() / 10000) * 10000
							setAmount(
								Math.min(
									4950000,
									maxAvailable,
									amount + 50000
								)
							)
									}}>
									+5만
								</Button>
								<Button
									size="small"
									onClick={() => {
										const maxAvailable = Math.floor(available.toNumber() / 10000) * 10000
							setAmount(
								Math.min(
									4950000,
									maxAvailable,
									amount + 10000
								)
							)
									}}>
									+1만
								</Button>
								</Space.Compact>
						</Space>
					</Col>
				</Row>
				
				
				
				
				
				
				<Row style={{ marginTop: 10 }}>
					<Col span={24} style={{ textAlign: 'right' }}>
						<Button
							type="primary"
							icon={<IconSend size={14} />}
							onClick={() => {
								if (amount < 100000) {
									if (mobile) {
										alert('출금액은 10만원 이상이어야 합니다.')
									} else {
										message.error('출금액은 10만원 이상이어야 합니다.')
									}
									return
								}

					if (amount > 4950000) {
						if (mobile) {
							alert('출금액은 495만원 이하여야 합니다.')
						} else {
							message.error('출금액은 495만원 이하여야 합니다.')
						}
						return
					}

								if(profile?.level !== 1){
									if (mobile) {
										alert('일반회원만 출금이 가능합니다')
									} else {
										message.error('일반회원만 출금이 가능합니다')
									}
									return;
								}

								handleSellClick();

								// if (profile?.level != 6 && profile?.level != 7){
								// 	if (name?.length < 1) {
								// 		message.error(
								// 			'출금자명을 확인해주세요.'
								// 		)
								// 		return
								// 	}
								// 	if (!bank) {
								// 		message.error('은행명을 확인해주세요.')
								// 		return
								// 	}
								// 	if (!account) {
								// 		message.error(
								// 			'계좌번호를 확인해주세요.'
								// 		)
								// 		return
								// 	}
								// }

								// API.post('/cash/request', token + '', {
								// 	type: 'W',
								// 	amount,
								// 	bankaccount:
								// 		bank + ' ' + account + ' ' + name,
								// 	name,
								// }).then(res => {
								// 	if (res?.result?.success) {
								// 		message.success(
								// 			'출금신청이 완료되었습니다.'
								// 		)
								// 	} else {
								// 		message.error(
								// 			res?.result?.message ||
								// 				'출금신청에 실패하였습니다.'
								// 		)
								// 	}
								// 	mutateModalStore({
								// 		...modalStore,
								// 		gDeposit: false,
								// 	})
								// })
							}}>
							출금신청
						</Button>
					</Col>
				</Row>
			</Space>

			{mobile ? (
				<div
					style={{
						width: '100%',
						minWidth: 330,
						height: 200,
						overflowY: 'auto',
						overflowX: 'hidden',
						border: '1px solid #cdcdcd',
						padding: 5,
						marginTop: 10,
						whiteSpace: 'pre-wrap',
					}}>
					{data}
				</div>
			) : (
				<div
					style={{
						width: '100%',
						minWidth: 527,
						height: 595,
						overflowY: 'auto',
						overflowX: 'hidden',
						border: '1px solid #cdcdcd',
						padding: 5,
						marginTop: 10,
						whiteSpace: 'pre-wrap',
					}}>
					{data}
				</div>
			)}
		</Space>
	)
}

export default React.memo(PGWithdraw)
